import React from 'react';
import {
  Modal,
  Row,
  Col,
} from 'react-bootstrap';

import OrdersActionCreators from 'actions/OrdersActionCreators';
import { useTranslation } from 'react-i18next';

const RemoveEquipmentModal = (props) => {
  const { t } = useTranslation();
  return (
    <Modal show={props.show} bsSize="sm" enforceFocus={false}>
      <Modal.Header >
        <Modal.Title>{t('REMOVE_CONTAINER_WITH_VALUE', { value: props.equipmentId })}?</Modal.Title>
      </Modal.Header>
      <Modal.Footer>
        <Row>
          <Col xs={5}></Col>
          <Col xs={7} >
            <div className="flex flex-row">
              <button
                className="button button-green hover:bg-green-dark text-white"
                onClick={() => {
                  OrdersActionCreators.removeEquipmentFromOrder(props.orderId, props._id);
                  props.onClose();
                }}
              >
                {t('CONFIRM')}
              </button>
              <button
                className="button bg-white text-grey hover:text-grey-dark"
                onClick={() => {
                  props.onClose();
                }}
              >
                {t('CANCEL')}
              </button>
            </div>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}

export default RemoveEquipmentModal;
